import { DEFAULT_BLOCK_BACKGROUND_PALETTE, resolveBlockBackgroundPalette, } from "@diality/contracts";
/** Literal classes keep Tailwind's scanner aware of every supported surface. */
const BACKGROUND_PALETTE_CLASS = {
    transparent: "bg-[var(--block-background,#00000000)]",
    white: "bg-[var(--block-background,#FFFFFF)]",
    "light-blue": "bg-[var(--block-background,#E8F2FA)]",
};
export function blockBackgroundPaletteClass(value) {
    return BACKGROUND_PALETTE_CLASS[resolveBlockBackgroundPalette(value, DEFAULT_BLOCK_BACKGROUND_PALETTE)];
}
//# sourceMappingURL=background-palette.js.map